import { render, staticRenderFns } from "./NewArea.vue?vue&type=template&id=a7561286&scoped=true"
import script from "./NewArea.vue?vue&type=script&lang=js"
export * from "./NewArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7561286",
  null
  
)

export default component.exports